import React from "react";
import styles from "../scss/ProviderDashboard.module.scss";

const ProviderDashboardContainer = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default ProviderDashboardContainer;
